import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { MEN_BASIC_Schema } from './MEN_BASIC_Schema';

export const useSearchCode = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['Utility', 'getCodeInfo'],
    queryFn: () => apiRequest('post', Global.urls.Utility.getCodeInfo),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;

    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearchMenuUp = (options = {}) => {
  const { onSuccess } = options;
  const query = useQuery({
    queryKey: ['Menu', 'getMenBasicR0MenuUp'],
    queryFn: () => apiRequest('post', Global.urls.Menu.getMenBasicR0MenuUp, {}),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: (rows) => onSuccess?.(rows || []),
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;

  const query = useQuery({
    queryKey: ['Menu', 'getMenBasicR1', 'MEN_BASIC'],
    queryFn: () => {
      const params = mapParamsBySchema(MEN_BASIC_Schema.mapper.search1, {
        params: '',
      });
      return apiRequest('post', Global.urls.Menu.getMenBasicR1, params);
    },
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

export const useSearch2 = (options = {}) => {
  return useSearchMutaion((params) => {
    const apiParams = mapParamsBySchema(
      MEN_BASIC_Schema.mapper.search2,
      params || {}
    );
    return apiRequest('post', Global.urls.Menu.getMenBasicR2, apiParams);
  }, options);
};

export const useSave1 = (context = {}, options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEN_BASIC_Schema.mapper.save1, context);
    return apiRequest('post1', Global.urls.Menu.saveMenBasicU1, payload);
  }, options);
};

export const useSave2 = (context = {}, options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEN_BASIC_Schema.mapper.save2, context);
    return apiRequest('post1', Global.urls.Menu.saveMenBasicU2, payload);
  }, options);
};

export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEN_BASIC_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Menu.deleteMenBasicD1, payload);
  }, options);
};

export const useDelete2 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, MEN_BASIC_Schema.mapper.delete2);
    return apiRequest('post1', Global.urls.Menu.deleteMenBasicD2, payload);
  }, options);
};
